import { DatePivotParams } from "../../entities/date_pivot_params";

// Canonical (apostrophe-free) status labels sent to the backend filter.
// Keep in sync with NEW_POS_TO_PLACE in the supply_walk_editable_goodchop transform.
export const NEEDS_REVIEW_NEW_POS_TO_PLACE = "Needs Review: New POs to Place";
export const NEEDS_REVIEW_OPEN_PO_MODIFICATIONS =
  "Needs Review: Open PO Modifications";

export const defaultConfig: DatePivotParams = {
  dateHierarchy: "day",
  segments: [],
  filters: [["status", "in", ["Needs Review"]]],
};

export const defaultConfigGoodchop: DatePivotParams = {
  dateHierarchy: "day",
  segments: [],
  filters: [["status", "in", [NEEDS_REVIEW_NEW_POS_TO_PLACE]]],
};
